import { emailSchema, phoneNumberSchema, stringSchema } from 'schema/validator'

export const fullNameSchema = stringSchema(40)
export const departmentSchema = stringSchema(50)
export const cellPhoneSchema = phoneNumberSchema
export const postSchema = stringSchema(50)
export const mailSchema = emailSchema
